export type { ScrollFrameProps } from './ScrollFrame';
import UserScroll from './ScrollFrame';
import ScrollFrameItem from './ScrollFrameItem';

type UserScrollType = typeof UserScroll;

interface ScrollFrameInterface extends UserScrollType {
  Item: typeof ScrollFrameItem;
}

const ScrollFrame = UserScroll as ScrollFrameInterface;
ScrollFrame.Item = ScrollFrameItem;

export default ScrollFrame;
